var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-column" }, [
    _c(
      "div",
      {
        staticClass:
          "settings-template container-big flex flex-column ov-reset self-center wp-10"
      },
      [
        _c(
          "div",
          { staticClass: "header mb-3" },
          [
            _c("h1", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Réglages")))
            ]),
            _vm._v(" "),
            _c("CompassBackForwardButton", {
              attrs: {
                label: _vm.$t.__("settings.SettingsTemplate.back_settings"),
                link: _vm.backUrl,
                back: ""
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-row hp-10 body" },
          [
            _vm.isCustomMenu
              ? _c(
                  "div",
                  { staticClass: "settings-nav clearfix flex-column" },
                  [
                    _vm._t(
                      "menu",
                      _vm._l(_vm.menuItems, function(item, key) {
                        return _c(
                          "div",
                          {
                            key: key,
                            ref: "subMenu",
                            refInFor: true,
                            staticClass:
                              "wp-10 flex-row sub-menu jc-space ai-center p-2 cpointer",
                            class: { selected: _vm.isSelected(item) },
                            on: {
                              click: function($event) {
                                return _vm.onMenuClick(item)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-bold sub-menu__text"
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.label) +
                                    "\n                        "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("CompassIcon", {
                              attrs: {
                                icon: "caret-right",
                                size: "extra-small",
                                type: "primary"
                              }
                            })
                          ],
                          1
                        )
                      })
                    )
                  ],
                  2
                )
              : _c(
                  "div",
                  { staticClass: "settings-nav clearfix flex-column" },
                  [
                    _vm._t(
                      "menu",
                      _vm._l(_vm.menu, function(item, key, index) {
                        return _c(
                          "div",
                          { key: key, staticClass: "wp-10 cpointer" },
                          [
                            _c(
                              "div",
                              {
                                ref: "subMenu",
                                refInFor: true,
                                staticClass:
                                  "sub-menu flex-row jc-space ai-center p-2",
                                attrs: { id: key },
                                on: {
                                  click: function($event) {
                                    return _vm.onMenuClick(item, index)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "typographies-paragraph-medium-bold gray-80"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.label) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("CompassIcon", {
                                  attrs: {
                                    icon: "caret-right",
                                    size: "extra-small",
                                    type: "primary"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "sub-menu-content flex-column" },
                              _vm._l(item.sub, function(subItem, subKey) {
                                return _c(
                                  "div",
                                  {
                                    key: subKey,
                                    staticClass:
                                      "sub-menu-content-item cpointer",
                                    class: _vm.isSelected(subItem)
                                      ? "selected"
                                      : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.onSubMenuClick(key, subItem)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "typographies-paragraph-medium-regular"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(subItem.label) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]
                        )
                      })
                    )
                  ],
                  2
                ),
            _vm._v(" "),
            _c("router-view", { staticClass: "content" })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }